/**
 * Indian Rupee (₹) icon in the app's line-icon style.
 *
 * Replaces the Feather "dollar-sign" glyph so all money/fee affordances use ₹.
 * Omit `size` to let CSS control the dimensions (e.g. sidebar nav icons).
 */
type RupeeIconProps = {
    size?: number | string;
    strokeWidth?: number;
    className?: string;
};

export default function RupeeIcon({ size, strokeWidth = 2, className }: RupeeIconProps) {
    return (
        <svg
            {...(size != null ? { width: size, height: size } : {})}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
        >
            <path d="M6 3h12" />
            <path d="M6 8h12" />
            <path d="m6 13 8.5 8" />
            <path d="M6 13h3" />
            <path d="M9 13c6.667 0 6.667-10 0-10" />
        </svg>
    );
}
